Ext.define('SA.VectorMapExportCropBox', {
    alias: 'widget.vector-map-export-crop-box',
    extend: 'Ext.Component',

    childEls: ['tlEl', 'tEl', 'trEl', 'lEl', 'holeEl', 'rEl', 'blEl', 'bEl', 'brEl'],
    cls: 'x-unselectable',
    floating: true,

    renderTpl: [
        '<div id="{id}-tlEl" class="sa-crop-box-mask sa-crop-box-mask-tl"></div>',
        '<div id="{id}-tEl" class="sa-crop-box-mask sa-crop-box-mask-t"></div>',
        '<div id="{id}-trEl" class="sa-crop-box-mask sa-crop-box-mask-tr"></div>',
        '<div id="{id}-lEl" class="sa-crop-box-mask sa-crop-box-mask-l"></div>',
        '<div id="{id}-holeEl" class="sa-crop-box-mask-hole"></div>',
        '<div id="{id}-rEl" class="sa-crop-box-mask sa-crop-box-mask-r"></div>',
        '<div id="{id}-blEl" class="sa-crop-box-mask sa-crop-box-mask-bl"></div>',
        '<div id="{id}-bEl" class="sa-crop-box-mask sa-crop-box-mask-b"></div>',
        '<div id="{id}-brEl" class="sa-crop-box-mask sa-crop-box-mask-br"></div>'
    ],

    afterRender() {
        this.callParent();

        this.mon(this.extent, 'set:bounds', this.refresh, this);

        this.holeEl.on({
            scope: this,

            mousedown: this.onHoleMouseDown,
            touchstart: this.onHoleMouseDown
        });

        this.el.on({
            delegate: '.sa-crop-box-mask',
            scope: this,

            mousedown: this.onDragHandleMouseDown,
            touchstart: this.onDragHandleMouseDown
        });
    },

    createDragMask(dragEl) {
        return Ext.getBody().appendChild({
            cls: 'sa-crop-box-drag-mask',
            style: 'cursor:' + Ext.fly(dragEl).getStyle('cursor')
        }, true);
    },

    createMouseMoveHandler(ev, xBias, yBias, aspect) {
        var startXY = ev.getXY(),
            extent = this.extent,
            startPageBox = this.previewMap.extentToPageBox(extent),
            imageXY = this.previewMap.map.getXY(),
            imageSize = this.previewMap.map.getSize(),
            constrain = Ext.Number.constrain,
            aspectRatio = this.aspectRatio,

            widthBefore = startPageBox.x - imageXY[0],
            widthAfter = imageSize.width - startPageBox.width - widthBefore,

            heightAbove = startPageBox.y - imageXY[1],
            heightBelow = imageSize.height - startPageBox.height - heightAbove,

            maxWidth = startPageBox.width + (xBias && widthBefore) + ((1 - xBias) && widthAfter),
            maxHeight = startPageBox.height + (yBias && heightAbove) + ((1 - yBias) && heightBelow),

            xDelta = 1 - 2 * xBias,
            yDelta = 1 - 2 * yBias,

            touchId;

        if (ev.type === 'touchstart') {
            touchId = ev.browserEvent.changedTouches[0].identifier;
        }

        if (aspectRatio) {
            maxWidth = Math.min(maxWidth, imageSize.height / aspectRatio);
            maxHeight = Math.min(maxHeight, imageSize.width * aspectRatio);
        }

        return ev => {
            ev.preventDefault();

            if (touchId && touchId !== ev.browserEvent.changedTouches[0].identifier) {
                return;
            }

            var newXY = ev.getXY(),
                width = constrain(startPageBox.width + xDelta * (newXY[0] - startXY[0]), 50, maxWidth),
                height = constrain(startPageBox.height + yDelta * (newXY[1] - startXY[1]), 50, maxHeight),
                newPageBox;

            if (aspectRatio) {
                switch (aspect) {
                    case 'height':
                        height = width * aspectRatio;
                        break;
                    case 'width':
                        width = height / aspectRatio;
                        break;
                    case 'both':
                        height = constrain(height, 50, width * aspectRatio);
                        width = constrain(width, 50, height / aspectRatio);
                        break;
                }
            }

            newPageBox = {
                height,
                width,

                x: constrain(
                    startPageBox.x + xBias * (startPageBox.width - width),
                    imageXY[0],
                    imageXY[0] + imageSize.width - width
                ),

                y: constrain(
                    startPageBox.y + yBias * (startPageBox.height - height),
                    imageXY[1],
                    imageXY[1] + imageSize.height - height
                )
            };

            extent.setBounds(this.previewMap.pageBoxToExtent(newPageBox));
        };
    },


    onDragHandleMouseDown(ev, target) {
        var doc = Ext.getDoc(),
            mask = this.createDragMask(target),
            mousemove = this.createMouseMoveHandler.apply(this, {
                b: [ev, 0.5, 0, 'width'],
                t: [ev, 0.5, 1, 'width'],
                l: [ev, 1, 0.5, 'height'],
                r: [ev, 0, 0.5, 'height'],
                br: [ev, 0, 0, 'both'],
                bl: [ev, 1, 0, 'both'],
                tl: [ev, 1, 1, 'both'],
                tr: [ev, 0, 1, 'both']
            }[target.className.match(/sa-crop-box-mask-([tblr]+)/)[1]]),
            isTouch = ev.type === 'touchstart';

        if (isTouch) {
            doc.on('touchcancel', mouseup);
            doc.on('touchend', mouseup);
            doc.on('touchmove', mousemove);
        }
        else {
            doc.on('mouseup', mouseup);
            doc.on('mousemove', mousemove);
        }

        function mouseup() {
            if (isTouch) {
                doc.un('touchcancel', mouseup);
                doc.un('touchend', mouseup);
                doc.un('touchmove', mousemove);
            }
            else {
                doc.un('mouseup', mouseup);
                doc.un('mousemove', mousemove);
            }

            Ext.removeNode(mask);
        }
    },

    onHoleMouseDown(ev, target) {
        var me = this,
            doc = Ext.getDoc(),
            mask = this.createDragMask(target),
            startXY = ev.getXY(),
            extent = this.extent,
            startPageBox = this.previewMap.extentToPageBox(extent),
            minXY = this.previewMap.map.getXY(),
            imageSize = this.previewMap.map.getSize(),
            constrain = Ext.Number.constrain,
            isTouch = ev.type === 'touchstart',
            maxXY = [
                minXY[0] + imageSize.width - Math.round(startPageBox.width),
                minXY[1] + imageSize.height - Math.round(startPageBox.height)
            ],
            touchId;

        if (isTouch) {
            touchId = ev.browserEvent.changedTouches[0].identifier;

            doc.on('touchcancel', mouseup);
            doc.on('touchend', mouseup);
            doc.on('touchmove', mousemove);
        }
        else {
            doc.on('mouseup', mouseup);
            doc.on('mousemove', mousemove);
        }

        function mousemove(ev) {
            ev.preventDefault();

            if (touchId && touchId !== ev.browserEvent.changedTouches[0].identifier) {
                mouseup();
                return;
            }

            var newXY = ev.getXY(),
                newPageBox = {
                    height: startPageBox.height,
                    width: startPageBox.width,
                    x: constrain(startPageBox.x + newXY[0] - startXY[0], minXY[0], maxXY[0]),
                    y: constrain(startPageBox.y + newXY[1] - startXY[1], minXY[1], maxXY[1])
                };

            extent.setBounds(me.previewMap.pageBoxToExtent(newPageBox));
        }

        function mouseup() {
            if (isTouch) {
                doc.un('touchcancel', mouseup);
                doc.un('touchend', mouseup);
                doc.un('touchmove', mousemove);
            }
            else {
                doc.un('mouseup', mouseup);
                doc.un('mousemove', mousemove);
            }

            Ext.removeNode(mask);
        }
    },

    refresh() {
        var extent = this.extent,
            outerPageBox = this.getPosition(),
            pageBox = this.previewMap.extentToPageBox(extent),
            left = Math.round(pageBox.x - outerPageBox[0]),
            top = Math.round(pageBox.y - outerPageBox[1]),
            height = Math.round(pageBox.height),
            width = Math.round(pageBox.width);

        this.tlEl.setStyle({
            height: top + 'px',
            width: left + 'px'
        });

        this.tEl.setStyle({
            height: top + 'px',
            left: left + 'px',
            width: width + 'px'
        });

        this.trEl.setStyle({
            height: top + 'px',
            left: (left + width) + 'px'
        });

        this.lEl.setStyle({
            height: height + 'px',
            top: top + 'px',
            width: left + 'px'
        });

        this.holeEl.setStyle({
            height: height + 'px',
            left: left + 'px',
            top: top + 'px',
            width: width + 'px'
        });

        this.rEl.setStyle({
            height: height + 'px',
            left: (left + width) + 'px',
            top: top + 'px'
        });

        this.blEl.setStyle({
            top: (top + height) + 'px',
            width: left + 'px'
        });

        this.bEl.setStyle({
            left: left + 'px',
            top: (top + height) + 'px',
            width: width + 'px'
        });

        this.brEl.setStyle({
            left: (left + width) + 'px',
            top: (top + height) + 'px'
        });
    },

    setAspectRatio(aspectRatio) {
        var extent = this.extent,
            startPageBox = this.previewMap.extentToPageBox(extent),
            constrain = Ext.Number.constrain,
            imageXY = this.previewMap.map.getXY(),
            imageSize = this.previewMap.map.getSize(),
            height, width;

        this.aspectRatio = aspectRatio;

        if (aspectRatio) {
            width = constrain(Math.sqrt(startPageBox.height * startPageBox.width / aspectRatio), 50, imageSize.width);
            height = constrain(width * aspectRatio, 50, imageSize.height);
            width = constrain(height / aspectRatio, 50, imageSize.width);

            extent.setBounds(this.previewMap.pageBoxToExtent({
                height,
                width,

                x: constrain(
                    startPageBox.x + 0.5 * (startPageBox.width - width),
                    imageXY[0],
                    imageXY[0] + imageSize.width - width
                ),

                y: constrain(
                    startPageBox.y + 0.5 * (startPageBox.height - height),
                    imageXY[1],
                    imageXY[1] + imageSize.height - height
                )
            }));
        }
    }
});